<template>
  <div class="frisbuy-goods-popup-wrapper" ref="goodsPopup">
    <div class="frisbuy-goods-popup">
      <div
        class="frisbuy-goods-popup__close-button"
        @click.stop="$emit('closePopup')"
        v-touch:swipe="(direction) => closeButtonSwipeHandler(direction)"
      ></div>
      <div class="frisbuy-goods-popup-items" body-scroll-lock-ignore>
        <GoodItem
          v-for="good in goods"
          :key="good.id"
          :good="good"
          :currencySymbol="currencySymbol"
          @clickLink="(good) => $emit('clickLink', good)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-goods-popup-wrapper {
  position: absolute;
  bottom: 0;

  background: #ffffff;
  border-radius: 22px 22px 0px 0px;

  width: 100%;

  // padding: 20px 0 104px;
  // padding: 26px 20px 64px;
  padding: 26px 0 64px;

  z-index: 11;

  @media screen and (min-width: 768px) {
    padding-bottom: 71px;
  }

  .frisbuy-goods-popup {
    position: relative;
    width: 100%;
    height: 100%;

    &__close-button {
      position: absolute;
      top: -39px;
      left: 50%;
      transform: translateX(-50%);

      width: 58px;
      height: 5px;

      background: rgba(255, 255, 255, 0.6);
      mix-blend-mode: normal;
      border-radius: 2.5px;
    }

    &-items {
      display: flex;
      flex-direction: row;

      height: calc(270px + 16px); // 16px - bottom padding for scrollba;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      scroll-behavior: smooth;

      padding: 0 20px 16px;

      &::-webkit-scrollbar {
        height: 5px;

        padding: 0 2px;
      }
      &::-webkit-scrollbar-button {
        display: none;
        background: #ccc;
      }
      &::-webkit-scrollbar-track-piece {
        background: #efefef;
        margin: 0 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #afafaf;
        border-radius: 8px;
      }

      @media screen and (max-width: 767px) {
        height: 270px;
        scrollbar-color: transparent transparent;
        padding-bottom: 0;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      & > .frisbuy-good-item:not(:first-child) {
        margin-left: 14px;
      }
    }
  }
}
</style>

<script>
import GoodItem from "./GoodItem.vue";

export default {
  components: { GoodItem },

  emits: ["clickLink", "closePopup"],

  props: {
    goods: {
      type: Array,
      require: true,
    },

    currencySymbol: {
      type: String,
      require: false,
      default: undefined,
    },
  },

  data() {
    return {};
  },

  methods: {
    closeButtonSwipeHandler(direction) {
      if (direction === "bottom") {
        this.$emit("closePopup");
      }
    },
  },
};
</script>
